<template>
  <div ref="container">
    <Label
      v-bind="labelProps"
      :html-for="id"
      :bold="labelBold"
      v-if="label"
      :disabled="disabled"
      class="label"
    >
      {{ label }}
    </Label>
    <template v-if="!register || !!options.length || !handleRegister">
      <vSelect
        :class="classes"
        :label="labelBusca"
        :ref="refBusca"
        :value="value"
        :filterable="filterable"
        :options="options"
        :id="id"
        :disabled="disabled"
        :placeholder="placeholder"
        @open="handleOpen"
        @search="handleSearch"
        @search:focus="() => handleFocus(true)"
        @search:blur="() => handleFocus(false)"
        @input="handleChange"
      >
        <template slot="option" slot-scope="option" v-if="!!options">
          <slot name="options" :data="option">{{
            renderOptionValue(option)
          }}</slot>
        </template>
        <template slot="selected-option" slot-scope="option">
          <slot name="selected" :data="option"></slot>
        </template>
        <template slot="no-options"> Nenhum registro encontrado </template>
      </vSelect>
    </template>
    <template v-else>
      <vSelect
        :class="classes"
        :label="labelBusca"
        :filterable="filterable"
        :options="newRegister"
        :placeholder="placeholder"
        :disabled="disabled"
        @search="handleSearch"
        @open="handleOpen"
        @search:focus="() => handleFocus(true)"
        @search:blur="() => handleFocus(false)"
        :id="id"
        @input="handleRegisterValue"
      >
        <template slot="option" slot-scope="option">
          <slot name="options" :data="option">{{ option.name }}</slot>
        </template>
        <template slot="selected-option" slot-scope="option">
          <slot name="selected" :data="option">{{ option.name }}</slot>
        </template>
        <template slot="no-options">
          Preencha o campo para adicionar um novo registro
        </template>
      </vSelect>
    </template>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Label from './Label';

export default {
  name: 'SelectWithRegister',
  data() {
    return {
      rawSearch: '',
      focus: false,
      addValue: '',
    };
  },
  components: {
    vSelect,
    Label,
  },
  props: {
    busca: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disableResizeOptions: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
    },
    labelBold: {
      type: Boolean,
      default: () => true,
    },
    labelProps: {
      type: Object,
    },
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
    },
    labelBusca: {
      type: String,
    },
    renderOption: {
      type: Function,
      required: false,
      default: null,
    },
    refBusca: {
      type: String,
    },
    inputClass: {
      type: String,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    search: {
      type: Function,
      required: true,
    },
    handleRegister: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Array,
    },
    register: {
      type: Function,
      required: false,
      default: null,
    },
    registerLabel: {
      type: String,
    },
    change: {
      type: Function,
      required: false,
      default: () => null,
    },
    heightSmall: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    value: {
      type: Object,
    },
  },
  computed: {
    classes() {
      return {
        [this.inputClass]: true,
        error: this.error,
        focus: this.focus,
      };
    },
    newRegister() {
      return this.addValue
        ? [
            {
              name: 'Adicionar novo registro',
            },
          ]
        : [];
    },
  },
  methods: {
    handleSearch(search) {
      this.search(search);
      this.rawSearch = search;
      this.addValue = search;
    },
    handleChange(selected) {
      this.change(selected);
    },
    handleFocus(focus) {
      this.focus = focus;
    },
    handleRegisterValue() {
      this.register(this.addValue);
    },
    renderOptionValue(option) {
      return this.renderOption
        ? this.renderOption(option)
        : option[this.labelBusca];
    },
    handleOpen() {
      setTimeout(() => {
        const elAutocomplete = this.$refs.container.querySelector('.v-select');
        if (elAutocomplete) {
          const elInputAutocomplete =
            elAutocomplete.querySelector('.vs__search');
          const controls = elInputAutocomplete.getAttribute('aria-controls');
          const dropMenuEl = document.querySelectorAll(`#${controls}`);
          const clippContainer = document.querySelector('#clipp-container-app');

          const { left } = elAutocomplete.getBoundingClientRect();
          const { width: clippWidth } = clippContainer.getBoundingClientRect();

          dropMenuEl[dropMenuEl.length - 1].style.width = !this
            .disableResizeOptions
            ? `${clippWidth + 30 - left}px`
            : '100%';

          dropMenuEl[dropMenuEl.length - 1].style.maxHeight = this.heightSmall
            ? '200px'
            : '350px';
        }
      }, 50);
    },
  },
};
</script>
